import React from 'react';
import {View} from '../../app-components';
import PatientRequests from './PatientRequests';

export default {
  'patient-requests': {
    renderHeader: () => {
      return (
        <View
          style={{
            height: 1,
            marginTop: 5,
            width: '100%',
            backgroundColor: 'rgb(151,151,151, 0.34)',
          }}
        />
      );
    },
    screen: PatientRequests,
  },
};
